<!--
 * @Author: wumao
 * @Date: 2021-12-17 11:09:58
 * @LastEditors: wumao
 * @LastEditTime: 2021-12-17 11:56:45
 * @Description: 
-->
<template>
  <div class="title-wrapper">{{ text }}</div>
</template>

<script>
export default {
  props: ['text'],
}
</script>

<style lang="less" scoped>
.title-wrapper {
  font-size: 0.22rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.3rem;
  height: 0.3rem;
  &::before {
    content: '';
    display: inline-block;
    width: 0.04rem;
    height: 0.22rem;
    line-height: 0.22rem;
    background: #0072f7;
    margin-right: 0.1rem;
    transform: translateY(0.03rem);
  }
}
</style>
